import type { Disposable, Model } from '@patsnap/tahiti-core';
import type { ReferencePatentWithOrder } from '../types';

export interface ReferencePatentModel extends Model<ReferencePatentWithOrder[]>, Disposable {}

export const ReferencePatentModel = Symbol('ReferencePatentModel');
